import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
// import Diploma from '../views/Diploma.vue';
import GrafikaDiploma from '../views/GrafikaDiploma.vue';
import EvaluationPlatform from '../views/EvaluationPlatform.vue';
// import Evaluation from '../views/Evaluation.vue';

Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/:name/:course',
  //   name: 'Diploma',
  //   component: Diploma,
  //   props: true,
  // },
  {
    path: '/:name/:course',
    name: 'GrafikaDiploma',
    component: GrafikaDiploma,
    props: true,
  },
  {
    path: '/:shortURL',
    name: 'Evaluation',
    component: EvaluationPlatform,
    props: true,
  },
  {
    path: '/*',
    name: 'Home',
    component: Home,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;